import { Text as CText, HStack } from '@chakra-ui/react'
import { useRef } from 'react'

import { Tooltip as CTooltip } from '../../Tooltip/Tooltip'

export type RechartsTooltip = {
  children?: (payload: any) => React.ReactNode
}

export const RechartsTooltip = (props: any) => {
  const ref = useRef<HTMLDivElement>(null)

  if (!props.active) {
    return null
  }

  return (
    <CTooltip
      isOpen
      label={
        <>
          {props.payload
            ?.filter(({ type }: any) => type !== 'none')
            .map(
              (
                { payload, value, name, color = 'presets.blue.50' }: any,
                index: number,
              ) => (
                <HStack key={index}>
                  <CText color={color}>●</CText>
                  <CText fontWeight="bold">{value ?? payload?.value}</CText>
                  <CText>{name ?? payload?.key ?? payload?.dataKey}</CText>
                </HStack>
              ),
            )}
        </>
      }
      portalProps={{ containerRef: ref }}
      hasArrow={true}
    >
      <span style={{ color: 'transparent' }} ref={ref}>
        .
      </span>
    </CTooltip>
  )
}
